import { useTranslation } from 'react-i18next';

import { Paragraph } from '@app/shared/ui/atoms/Common';

export function BottomNote() {
  const { t } = useTranslation();

  return (
    <Paragraph className="mt-auto pt-[30px] text-xs font-normal opacity-60">
      {t('daily_card_description.bottom_note')}
    </Paragraph>
  );
}
